import nprogress from 'nprogress';
import { ActionTypes, ProjectConfigurationActionTypes } from 'actionsConstants';
import { hitApi, ObservableAjax } from '__common/utils/api';
import {
  SET_LOADER_MSG,
  LOAD_AURORA_PROJECT_CONFIGURATION,
  REDIRECT_TO_AURORA_PROJECT,
  IMPORT_AURORA_PROJECT_SUCCESS,
} from 'actions';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { AnyAction, Store } from 'redux';
import { Observable, EMPTY, of } from 'rxjs';

export function auroraDesignConfigInitDataRequest(action$: Observable<AnyAction>, state$: Observable<appState>) {
  return action$.pipe(
    ofType(ActionTypes.AURORA_DESIGN_CONFIG_INIT_DATA_REQUEST),
    switchMap((action) => {
      const auroraTenantId = action.payload.auroraTenantId;
      const auroraProjectId = action.payload.auroraProjectId;
      const auroraDesignId = action.payload.auroraDesignId;
      const auroraUserId = action.payload.auroraUserId;
      const auroraSessionToken = action.payload.auroraSessionToken;
      const importPath = [
        auroraTenantId,
        auroraProjectId,
        auroraDesignId,
        auroraUserId,
        auroraSessionToken,
      ].map((value) => encodeURIComponent(value)).join('/');

      return ObservableAjax({
        until$: action$.pipe(ofType(ActionTypes.AURORA_DESIGN_CONFIG_INIT_DATA_SUCCESS)),
        onSuccess: LOAD_AURORA_PROJECT_CONFIGURATION,
        onErrorMessage: 'Cannot fetch project data',
        socketName: 'project',
        onSocketPending: 'Wait Syncing Aurora with U-builder.....',
        onSocketStart: 'Importing Aurora Design into U-builder',
        onSocketFailure: 'Aurora Import Failure......',
        onErrorAction: () => nprogress.done(),
        link: hitApi('get', `api/v1/aurora/${importPath}/`),
      });
    })
  );
}

export function importAuroraFullDesignProject(action$, state$: Observable<appState>) {
  return action$.pipe(
    ofType(ActionTypes.IMPORT_AURORA_FULL_DESIGN_PROJECT),
    switchMap((action) => {
      return ObservableAjax({
        onSuccess: [SET_LOADER_MSG.bind(null, 'Importing Aurora Full Design Project'), IMPORT_AURORA_PROJECT_SUCCESS],
        onErrorMessage: 'Cannot import project',
        socketName: 'project',
        onSocketFailure: 'AURORA FULL DESIGN IMPORT FAILURE',
        showBackendErrorMsgOnFailure: true,
        onErrorAction: () => nprogress.done(),
        link: hitApi('post', 'api/v1/aurora/full_design_import/', action.payload.data),
      });
    })
  );
}
export function redirectAuroraLandingPageAfterProjectConfig(action$: Observable<AnyAction>, state$: Observable<appState>): Observable<any> {
  return action$.pipe(
    ofType(ActionTypes.REDIRECT_AURORA_PAGE),
    withLatestFrom(state$),
    switchMap(([action, state]) => {
      const { projectConfiguration: { projectEnvConfig : { aurora_project_id , aurora_design_id } } } = state;
              
      return of(REDIRECT_TO_AURORA_PROJECT(aurora_project_id, aurora_design_id));
    })
  );
}